import { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categories } from '@/mocks/categories';
import { businesses } from '@/mocks/businesses';

function Categories() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');

  const getBusinessCount = (categoryName: string) => {
    return businesses.filter((b) => b.categoryName === categoryName).length;
  };

  const filtered = useMemo(() => {
    const q = searchQuery.trim().toLowerCase();
    if (!q) return categories;
    return categories.filter(
      (cat) =>
        cat.name.toLowerCase().includes(q) ||
        cat.description.toLowerCase().includes(q),
    );
  }, [searchQuery]);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <div className="pt-20 md:pt-24 pb-8 bg-background-100 border-b border-background-200/70">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-50 mb-2">
            Catégories d&apos;entreprises
          </h1>
          <p className="text-sm md:text-base text-foreground-400">
            Explorez les entreprises par secteur d&apos;activité.
          </p>

          <div className="mt-5 max-w-md">
            <div className="flex items-center bg-background-50 border border-background-200/70 rounded-lg overflow-hidden focus-within:border-primary-400">
              <div className="w-10 h-10 flex items-center justify-center shrink-0">
                <i className="ri-search-line text-foreground-400" />
              </div>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Rechercher une catégorie..."
                className="flex-1 bg-transparent text-sm text-foreground-50 placeholder:text-foreground-500 py-2.5 pr-3 outline-none"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 lg:px-12 py-12">
        {filtered.length === 0 ? (
          <div className="text-center py-16">
            <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-100 mb-4">
              <i className="ri-search-line text-2xl text-foreground-400" />
            </div>
            <p className="text-foreground-500 font-medium mb-2">Aucune catégorie trouvée</p>
            <p className="text-sm text-foreground-500">Essayez une autre recherche.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
            {filtered.map((category) => {
              const count = getBusinessCount(category.name);
              return (
                <button
                  key={category.id}
                  onClick={() => navigate(`/directory?category=${category.slug}`)}
                  className="group text-left p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-400/40 transition-all duration-300"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-500/10 mb-4 group-hover:bg-primary-500/20 transition-colors">
                    <i className={`${category.icon} text-2xl text-primary-400`} />
                  </div>
                  <h3 className="font-heading font-semibold text-lg text-foreground-50 mb-1">
                    {category.name}
                  </h3>
                  <p className="text-sm text-foreground-400 mb-3">
                    {category.description}
                  </p>
                  <p className="text-xs text-foreground-500">
                    {count} entreprise{count !== 1 ? 's' : ''}
                  </p>
                </button>
              );
            })}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}

export default Categories;